.wrapper {
    display: inline-flex;
    align-items: flex-start;
    gap: var(--tempest-space-2);
    cursor: pointer;
    user-select: none;
}

.wrapper.disabled {
    cursor: not-allowed;
    opacity: 0.55;
}

.input {
    position: absolute;
    opacity: 0;
    width: 1px;
    height: 1px;
    pointer-events: none;
}

.dot {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    border: 1.5px solid var(--tempest-border-strong);
    border-radius: 50%;
    background-color: var(--tempest-bg);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: var(--tempest-shadow-xs);
    transition: var(--tempest-transition-color), var(--tempest-transition-shadow);
}

.dot::after {
    content: "";
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: var(--tempest-primary);
    transform: scale(0);
    transition: transform var(--tempest-duration-base) var(--tempest-ease-emphasized);
}

.wrapper:hover:not(.disabled) .input:not(:checked) + .dot {
    border-color: var(--tempest-primary);
}

.input:checked + .dot {
    border-color: var(--tempest-primary);
}

.input:checked + .dot::after {
    transform: scale(1);
}

.input:focus-visible + .dot {
    outline: var(--tempest-focus-ring-width) solid var(--tempest-focus-ring-color);
    outline-offset: var(--tempest-focus-ring-offset);
}

.labelWrap {
    display: flex;
    flex-direction: column;
    gap: 2px;
    line-height: var(--tempest-leading-snug);
}

.label {
    font-size: var(--tempest-text-base);
    color: var(--tempest-text);
}

.description {
    font-size: var(--tempest-text-xs);
    color: var(--tempest-text-muted);
    line-height: var(--tempest-leading-snug);
}

.group {
    display: flex;
    flex-direction: column;
    gap: var(--tempest-space-2);
}

.group.horizontal {
    flex-direction: row;
    gap: var(--tempest-space-4);
    flex-wrap: wrap;
}
